import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./../../assets/scss/theme/public.scss";

const PublicLayout = () => {
  useEffect(() => {
    document.body.classList.add("public-theme");

    return () => {
      document.body.classList.remove("public-theme");
    };
  }, []);

  return <Outlet />;
};

export default PublicLayout;
